import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=5de6b6b1&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=5de6b6b1&lang=less&scoped=true&"
import style1 from "./Comment.vue?vue&type=style&index=1&id=5de6b6b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de6b6b1",
  null
  
)

export default component.exports